module.exports = __webpack_public_path__ + "img/icon_05.ad752ad7.svg";